__turbopack_context__.v({
  "content": "content-module__USDWmW__content",
});
